export interface SortableTemplate {
  id: string;
  name: string;
  is_default?: boolean | null;
  is_public?: boolean | null;
}

export function sortUserTemplates<T extends SortableTemplate>(kits: readonly T[]): T[] {
  return kits
    .slice()
    .sort((a, b) => {
      if (Boolean(a.is_default) !== Boolean(b.is_default)) {
        return a.is_default ? -1 : 1;
      }
      return a.name.localeCompare(b.name);
    });
}

export function groupTemplatesForCarousel<T extends SortableTemplate>(kits: readonly T[]): {
  userKits: T[];
  publicKits: T[];
} {
  return {
    userKits: sortUserTemplates(kits.filter((kit) => !kit.is_public)),
    publicKits: sortUserTemplates(kits.filter((kit) => kit.is_public)),
  };
}
